import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(() => {
  let mp: any = null;
  const queue: Array<() => void> = [];

  const getMixpanel = async () => {
    if (!mp) {
      const { default: mixpanel } = await import('mixpanel-browser');
      mixpanel.init('38622f4c86f7f6ba6eafb6a4469d91a5', { persistence: 'localStorage' });
      mp = mixpanel;
      // Flush queued calls
      queue.forEach(fn => fn());
      queue.length = 0;
    }
    return mp;
  };

  // Stub API — queues track calls until library loads
  const stub = {
    track: (event: string, props?: object) => {
      getMixpanel().then(m => m.track(event, props));
    },
    identify: (id: string) => {
      getMixpanel().then(m => m.identify(id));
    },
    people: {
      set: (props: object) => {
        getMixpanel().then(m => m.people.set(props));
      },
    },
    init: () => {},
  };

  // Load after window load + delay to not block LCP/TTI
  if (typeof window !== 'undefined') {
    window.addEventListener('load', () => {
      setTimeout(() => getMixpanel(), 3000);
    }, { once: true });
  }

  return {
    provide: { mixpanel: stub },
  };
});
